// A note the person wrote in the Notebook. Props and callbacks only.
import React from 'react'
import { Box, Button, TextField } from '@mui/material'
import DisabledReason from '../../system/DisabledReason'

export interface NotebookNoteCellProps {
  text: string
  readOnlyReason?: string
  onChange: (text: string) => void
  onDelete: () => void
}

export const NotebookNoteCell: React.FC<NotebookNoteCellProps> = ({ text, readOnlyReason, onChange, onDelete }) => (
  <Box>
    <TextField
      fullWidth
      multiline
      minRows={2}
      size="small"
      placeholder="Write a note"
      value={text}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{ htmlInput: { readOnly: !!readOnlyReason, maxLength: 4000, 'aria-label': 'Note', 'data-testid': 'notebook-note-text' } }}
    />
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
      <DisabledReason reason={readOnlyReason}>
        <Button size="small" color="info" onClick={onDelete} data-testid="notebook-note-delete">
          Delete note
        </Button>
      </DisabledReason>
    </Box>
  </Box>
)

export default NotebookNoteCell
